import {
  SpecialtyPage,
  SpecialtyPageStaticDataProps,
} from '@/features/specialty-page';
import JobBlocksService from '@/features/specialty-page/services/job-blocks.service';
import RelatedLinksService from '@/features/specialty-page/services/related-links.service';
import SearchAdventuresService from '@/features/specialty-page/services/search-adventure.service';
import SpecialtyCtasService from '@/features/specialty-page/services/specialty-ctas.service';

const get = async (
  specialtyPage: SpecialtyPage
): Promise<SpecialtyPageStaticDataProps> => {
  const [searchAdventures, relatedLinks, jobBlocks, ctas] = await Promise.all([
    SearchAdventuresService.get(specialtyPage),
    RelatedLinksService.get(specialtyPage),
    JobBlocksService.getAll(specialtyPage),
    SpecialtyCtasService.get(specialtyPage),
  ]);

  return { searchAdventures, relatedLinks, jobBlocks, ctas };
};

const SpecialtyPageStaticDataService = {
  get,
};

export default SpecialtyPageStaticDataService;
